/** Saving the caller's own language to their profile. */
import type { AuthUser, Locale } from '@daka/core';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { setDeviceLocale } from '@/i18n/device-locale';
import { platform } from '@/lib/api';
import { unwrap } from '@/lib/http';
import { queryKeys } from '@/lib/queryKeys';

/** Save the caller's language to their profile. */
export function saveLocale(locale: Locale): Promise<AuthUser> {
   return unwrap(platform.me.$patch({ json: { locale } }));
}

export function useUpdateLocale() {
   const queryClient = useQueryClient();
   return useMutation({
      mutationFn: saveLocale,
      onSuccess: (user) => {
         setDeviceLocale(user.locale);
         queryClient.setQueryData(queryKeys.session, user);
      }
   });
}
